import { defineComponent as _defineComponent } from 'vue'
import { defineAsyncComponent } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'lookup-confirmation',
  props: {
    lookupDetails: { default: () => [] },
    flightNumber: { default: '' },
    hideChangeVehicleInfo: { type: Boolean, default: false }
  },
  emits: ["edit-details"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'edit-details'): void
}), expose: any, slots: any, attrs: any }) {

const IconCheck = defineAsyncComponent(() => import('@white-label-icon/icon-check'));





return { __sfc: true,IconCheck, emit }
}

})